// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import ArrowUpOutlinedSvg from "@fishx/icons-svg/es/asn/ArrowUpOutlined";
import FishxIcon from '../components/FishxIcon';

var ArrowUpOutlined = function ArrowUpOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: ArrowUpOutlinedSvg
  }));
};

ArrowUpOutlined.displayName = 'ArrowUpOutlined';
export default React.forwardRef(ArrowUpOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/ArrowUpOutlined.js
// module id = 2026
// module chunks = 0